import script from "./trial-discount-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./trial-discount-bar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__